import { Col, Form, List, Radio, Row, Typography } from "antd";
import React from "react";
import { memoryFieldsOptions } from "../../../../Options/physioOptions";
import { DislikeOutlined, LikeOutlined } from "@ant-design/icons";

const DelayedRecall = ({ psych = false, setDelayedRecall }) => {
  const handleChange = (value, fieldValue) => {
    setDelayedRecall((prev) => ({
      ...prev,
      [fieldValue]: value,
    }));
  };
  return (
    <>
      <List
        bordered={false}
        className="moca-section-card moca-memory-list"
        dataSource={memoryFieldsOptions}
       style={{
  width: "100%",
  maxWidth: psych ? "100%" : "600px",
  margin: "0 auto",
  padding: "20px",
}}
        renderItem={(field) => (
          <List.Item>
            <Row style={{ width: "100%" }} align="middle" gutter={[8, 8]}>
              <Col xs={24} md={12}>
                <Typography>{field.label}</Typography>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name={
                    psych === true
                      ? ["moca", "delayed_recall_data", field.value]
                      : ["delayed_recall_data", field.value]
                  }
                  style={{ marginBottom: 0 }}
                >
                  <Radio.Group
                    style={{ width: "100%" }}
                    onChange={(e) =>
                      handleChange(e?.target?.value, field.value)
                    }
                  >
                    <Row justify="space-around">
                      <Col>
                        <Radio.Button value={"yes"} className="like-btn">
                          <LikeOutlined />
                        </Radio.Button>
                      </Col>
                      <Col>
                        <Radio.Button value={"no"} className="dislike-btn">
                          <DislikeOutlined style={{ backgroundColor: "" }} />
                        </Radio.Button>
                      </Col>
                    </Row>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </List.Item>
        )}
      />
    </>
  );
};

export default DelayedRecall;
